<template>
  <OButton pure class="bg-o-blue text-white w-full font-bold h-12 sm:h-16 sm:text-xl rounded" v-bind="$attrs" v-on="$listeners">
    {{ $t('news-page.show-comments') }}
  </OButton>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OButton } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OButton },
  setup() {},
});
</script>
